import {Button, Layout, Ruler, Spacer, Spinner, Text} from '@di-nxt/components';
import React, {useCallback, useMemo} from 'react';
import {
  getWeekNumber,
  ScheduleCalendarType,
  useOptimizations,
  useOptimizationsOperations,
} from '../../../services';
import dayjs from 'dayjs';
import {t} from '../../../localization';

type Props = {
  teamId: number;
  calendarType: ScheduleCalendarType;
  selectedDate: Date;
};

export const RequestOptimizerButton: React.FC<Props> = ({
  teamId,
  calendarType,
  selectedDate,
}) => {
  const week = useMemo(() => getWeekNumber(selectedDate), [selectedDate]);
  const year = useMemo(() => dayjs(selectedDate).year(), [selectedDate]);

  const optimizations = useOptimizations(
    opt =>
      opt.week === week &&
      opt.year === year &&
      opt.teamId === teamId &&
      opt.status !== 'DONE',
  );

  const {create} = useOptimizationsOperations();

  const handleAddRequest = useCallback(() => {
    return (create({teamId, year, week}) as any) as Promise<void>;
  }, [create, teamId, week, year]);

  if (calendarType === 'week') {
    return (
      <>
         
        {optimizations.length > 0 &&
          (!optimizations[0].errorKey ? (
            <Layout
              padding="4"
              paddingHorizontal="12"
              centered
              horizontal
              backgroundColor="background_positive_light"
              borderRadius="4"
              borderColor="border_mono_15"
              borderStyle="solid"
              borderWidth="1">
              <Spinner size="Small" kind="Positive" />
              <Spacer width="12" />
              <Text>{t('screens.schedule.optimizer.generating')}</Text>
            </Layout>
          ) : (
            <Layout
              padding="4"
              paddingHorizontal="12"
              centered
              horizontal
              backgroundColor="background_negative_light"
              borderRadius="4"
              borderColor="border_mono_15"
              borderStyle="solid"
              borderWidth="1">
              <Text>
                {t(
                  // @ts-ignore
                  `screens.schedule.optimizer.errors.${optimizations[0].errorKey}`,
                )}
              </Text>
            </Layout>
          ))}
        {optimizations.length === 0 && (
          <Button
            kind="Primary"
            size="Small"
            title={t('screens.schedule.optimizer.request')}
            onPress={handleAddRequest}
          />
        )}
        <Spacer width="16" />
        <Ruler vertical width="1" />
        <Spacer width="8" />
      </>
    );
  }

  return null;
};
